import {createStore} from 'vuex';

import authModule from './auth/auth.js';
import customerNameInstance from "./pharma-customer-name/customer_name";
import customerSettingsInstance from "./pharma-customer-settings/customer_settings";
import cmsContentBlock from "./pharma-cms-content-block";
import cmsContentPage from "./pharma-cms-content-page";
import cmsPharmacy from "@/store/pharma-cms-pharmacy/cms_pharmacy";
import cpcMgmtModule from "@/store/pharma-cpc-mgmt";
import cpcProduct from "@/store/pharma-cpc-product/cpc_product";
import licenseInfo from "@/store/pharma-license-license-info/license_info";
import orderSettings from "@/store/pharma-order-settings/order_settings";
import orderOrcaCustomerMgmt from "@/store/pharma-order-orca-customer-mgmt/order_orca_customer_mgmt";


const store = createStore({
    modules: {
        auth: authModule,
        customer_name: customerNameInstance,
        customer_settings: customerSettingsInstance,
        cms_content_block: cmsContentBlock,
        cms_content_page: cmsContentPage,
        cms_pharmacy: cmsPharmacy,
        cpc_mgmt: cpcMgmtModule,
        cpc_product: cpcProduct,
        license_info: licenseInfo,
        order_settings: orderSettings,
        order_orca_customer_mgmt: orderOrcaCustomerMgmt,
    },
});

export default store;
